import yellowProduct from "assets/products/balm-yellow.svg";
import blueProduct from "assets/products/balm-blue.svg";
import pinkProduct from "assets/products/balm-pink.svg";
import purpleProduct from "assets/products/balm-purple.svg";

import yellowOpen from "assets/products/PineappleCoconut.png";
import blueOpen from "assets/products/Vanilla.png";
import pinkOpen from "assets/products/LimeStrawberry.png";
import purpleOpen from "assets/products/WildBerry.png";

import jasmine from "assets/products/objects/blue/jasmine-flowers.png"
import cupcake from "assets/products/objects/blue/cupcake-with-fresh-strawberries.png"
import vanillaFlower from "assets/products/objects/blue/vanilla-flower.webp"
import vanillaBean from "assets/products/objects/blue/vanila-bean.png"

import slicedLime from "assets/products/objects/pink/sliced_lime.png"
import lime from "assets/products/objects/pink/fresh-lime.png"
import strawberry from "assets/products/objects/pink/strawberry.png"
import strawberry2 from "assets/products/objects/pink/strawberry2.png"

import raspberry from "assets/products/objects/purple/raspberry.png"
import rasberry from "assets/products/objects/purple/roseberry.png"
import blackRasberry from "assets/products/objects/purple/black-rasberry.png"
import ripeBerries from "assets/products/objects/purple/ripe-berries.png"

import pineapple from "assets/products/objects/yellow/pineapple.png"
import pineappleSlice from "assets/products/objects/yellow/pineapple-slide.png"
import coconut1 from "assets/products/objects/yellow/coconut-1.png";
import coconut2 from "assets/products/objects/yellow/coconut-2.png";

import milk from "assets/products/objects/milk.png";

import bg1 from 'assets/products/backgrounds/1.jpg'
import bg2 from 'assets/products/backgrounds/2.jpg'
import bg3 from 'assets/products/backgrounds/3.jpg'
import bg4 from 'assets/products/backgrounds/4.jpg'

export const circlePositioning = (array) => {
  const circleRadius = 300;
  const objects = [];

  for (let i = 0; i < array.length; i++) {
    const singleArray = array[i];
    const angle = (i * 2 * Math.PI) / array.length;
    const x = circleRadius * Math.cos(angle);
    const y = circleRadius * Math.sin(angle);

    const object = {
      ...singleArray,
      top: `${y}px`,
      left: `${x}px`,
    };

    objects.push(object);
  }

  return objects;
};

export const PRODUCTS = [
  {
    main_image: yellowProduct,
    open_image: yellowOpen,

    colors: {
      primary: "#7c57ff",
      secondary: "rgba(172,147,248,1)",
      earth: "#4EA963",
      text: "#F0E44A"
    },

    background: {
      img: bg1
    },

    texts: {
      title: 'آناناس و نارگیل',
      englishName: "Pineapple Coconut",
      subtitle: 'جزیره بالی',
      description: `
      <div>
        بالم لب دافی رو امتحان کن.

        حالا خودتو تو جزیره بالی تصور کن.
        
        توی بهشت آسیای شرقی با دنیای اعجاب‌انگیز زیر آبش.
        
        
        با یه پیراهن خنک و کلاه حصیری بزرگ.
        
        
        و بوی خوب آناناس و نارگیل...
        
        
        همینه همین بویی که داری حس و مزه میکنی.
      </div>
      `
    },

    objects: [
      { img: pineapple, left: -166, top: -220, width: 250 },
      { img: coconut2, left: -209, top: 130, width: 350 },
      { img: milk, left: 66, top: 0, width: 400 },
      { img: coconut1, left: 123, top: -206, width: 150 },
      { img: pineappleSlice, left: 265, top: 280, width: 500 },
    ],
  },

  {
    main_image: blueProduct,
    open_image: blueOpen,

    colors: {
      primary: "#ff6fd4",
      secondary: "#ff92e1",
      earth: "#53506A",
      text: "#9CD5DB"
    },

    background: {
      img: bg2
    },

    texts: {
      title: 'وانیل',
      englishName: "Vanilla",
      subtitle: 'قنادی پاریس',
      description: `
      <div>
      بالم لب دافی رو امتحان کن.

      حالا خودتو تو کوچه‌های پاریس تصور کن.
      
      داری از جلوی یه قنادی با میزهای شلوغ رد میشی.
      
      صدای موسیقی.
      
      تصویر گل‌ها و بوی خوب وانیل...
      
        همینه همین بویی که داری حس و مزه میکنی.
      </div>
      `
    },

    objects: [
      { img: vanillaFlower, left: -166, top: -220, width: 250 },
      { img: jasmine, left: -209, top: 130, width: 350 },
      { img: milk, left: 66, top: 0, width: 400 },

      { img: vanillaBean, left: 123, top: -206, width: 150 },
      { img: cupcake, left: 265, top: 280, width: 500 },
    ],
  },
  {
    main_image: pinkProduct,
    open_image: pinkOpen,

    colors: {
      primary: "#45d76c",
      secondary: "#6aec8a",
      earth: "#4BABB4",
      text: "#D8397B",
    },

    background: {
      img: bg3
    },

    texts: {
      title: 'توت فرنگی لیمو',
      englishName: "Lime Strawberry",
      subtitle: 'دریای مدیترانه',
      description: `
      <div>
      بالم لب دافی رو امتحان کن.

      حالا خودتو تو ساحل دریای مدیترانه تصور کن.
      

      پاهات توی آبه.
      
      
      صدای موج دریا رو میشنوی.
      
      
      منظره غروب آفتاب روبروته.
      
      
      یه نوشیدنی خنک تو دستته و بوی خوب لیمو و توت فرنگی...
      
      
      همینه همین بویی که داری حس و مزه میکنی.
      </div> 
       `
    },

    objects: [
      { img: slicedLime, left: -166, top: -220, width: 250 },
      { img: strawberry2, left: -209, top: 130, width: 350 },
      { img: milk, left: 66, top: 0, width: 400 },

      { img: strawberry, left: 123, top: -206, width: 150 },
      { img: lime, left: 265, top: 280, width: 500 },
    ],
  },
  {
    main_image: purpleProduct,
    open_image: purpleOpen,

    colors: {
      primary: "#2fb5ae",
      secondary: "#64d1ce",
      earth: "#467643",
      text: '#8D549F'
    },

    background: {
      img: bg4
    },

    texts: {
      title: 'توت وحشی',
      englishName: "Wild berry",
      subtitle: 'جنگل‌های آمازون',
      description: ` 
      <div>
      بالم لب دافی رو امتحان کن.

      حالا خودتو تو یه قایق وسط رودخونه جنگل‌های آمازون تصور کن.
      
      صدای پرنده‌ها.
      
      
      رطوبت و نم جنگل.
      
      
      یه مه غلیظ و بوی خوب توت وحشی...
      
      
      همینه همین بویی که داری حس و مزه میکنی.
      </div>
      `
    },

    objects: [
      { img: rasberry, left: -166, top: -220, width: 250 },
      { img: raspberry, left: -209, top: 130, width: 350 },
      { img: milk, left: 66, top: 0, width: 400 },

      { img: blackRasberry, left: 123, top: -206, width: 150 },
      { img: ripeBerries, left: 265, top: 280, width: 500 },
    ],
  },
];

export const DEFAULT_COLORS = {
  primary: "#ffffff",
  secondary: "#ffffff",
};
